import PermitteeAble from "~/mixins/permitteeAble";
import BuilderModel from "~/models/tracked/builderModel";
import Guid from "~/helpers/guid";
import {Hash} from "~/interfaces/hashInterfaces";

export default class Permittee<T extends BuilderModel> extends PermitteeAble(BuilderModel) {

  constructor(parent: T, json: Hash = {}, rootName: string) {
    super();
    this._rootName = rootName;
    this.defineProperty('client_id', json['client_id'] || Guid.create());
    this.defineProperty('reference_id', json['reference_id'] || null);
    let reference_type;
    if (json['reference_type'] || json['reference_type'] === 0) {
      reference_type = json['reference_type'];
    } else reference_type = null;
    this.defineProperty('reference_type', reference_type);
    this.defineProperty('organization_id_where_assigned',json["organization_id_where_assigned"] || null);
    this.setDefaultDisplay();
    this.loadFromJson(json, parent.rootModel);
    this.rootModel = parent.rootModel;
    this.parent = parent;
    this.setInDictionary();
  }
}